// Third-party
import React from 'react';
import { withFormik, FormikProps, Form } from 'formik';
import * as Yup from 'yup';

// Components
import { Button } from '@capintel/component-lib/button';
import { FormInput } from '../../components/forms';

// Utils
import { formatMessage } from '../../../utils/i18n';
import { Link } from 'react-router-dom';
import { FormattedMessageV2 } from '@/views/components/i18n';

type FormProps = {
  domain: string;
};

type ParentProps = {
  signingIn: boolean;
  onSubmit: (domain: string) => Promise<void>;
};

type Props = ParentProps & FormikProps<FormProps>;

const canSubmit = (props: Props) => {
  const { values, initialValues, isSubmitting, errors } = props;

  const hasErrors = Object.keys(errors).length > 0;
  const isDirty = values !== initialValues;

  return !hasErrors && isDirty && !isSubmitting;
};

const SSO = (props: Props) => (
  <>
    <FormattedMessageV2 className="form-title" toLocalize="Auth.SSO.Title" />

    <Form>
      <FormInput name="domain" label={formatMessage('Auth.Domain')} placeholder="capintel.io" />

      <div className="submit-container">
        <Button variant="primary" loading={props.signingIn} type="submit" disabled={!canSubmit(props)}>
          {formatMessage(props.signingIn ? 'Auth.LogingIn' : 'Auth.Continue')}
        </Button>

        <Link to="login" className="link">
          {formatMessage('Auth.SSO.LoginLink')}
        </Link>
      </div>
    </Form>
  </>
);

const LoginSchema = Yup.object().shape({
  domain: Yup.string().required(),
});

const formikWrapper = withFormik<Props, FormProps>({
  validationSchema: LoginSchema,
  mapPropsToValues: () => ({ domain: '' }),
  handleSubmit: ({ domain }, { props, setSubmitting }) => {
    props.onSubmit(domain).finally(() => {
      setSubmitting(false);
    });
  },
});

export default formikWrapper(SSO) as any;
